import { formatIngredientDisplay } from "../../shared/quantity";
import type { RecipeIngredient, RecipeStep } from "../../shared/recipes";

/** Moves a trailing parenthetical amount to the front, e.g. "gin (30 ml)" → "30 ml gin". */
export function formatIngredientName(name: string): string {
  const trimmed = name.trim();
  const match = /^(.*)\s+\(([^)]+)\)\s*$/.exec(trimmed);
  if (match === null) {
    return trimmed;
  }

  const food = match[1].trim();
  const quantity = match[2].trim();
  if (food.length === 0 || quantity.length === 0) {
    return trimmed;
  }

  return `${quantity} ${food}`;
}

export function ingredientLabelsForStep(
  step: RecipeStep,
  ingredients: readonly RecipeIngredient[],
  scaleFactor = 1
): string[] {
  return ingredientsForStep(step, ingredients).map((ingredient) => formatIngredientDisplay(ingredient, scaleFactor));
}

export function ingredientsForStep(step: RecipeStep, ingredients: readonly RecipeIngredient[]): RecipeIngredient[] {
  const ids = step.ingredientsUsed;
  if (ids === undefined || ids.length === 0) {
    return [];
  }

  const byId = new Map(ingredients.map((ingredient) => [ingredient.id, ingredient]));
  return ids
    .map((id) => byId.get(id))
    .filter((ingredient): ingredient is RecipeIngredient => ingredient !== undefined);
}
